<template>
  <WCCollapseCard
    headerBackground="var(--secondary-lighter-7)"
    class="border-0 mt-1"
    :isCollapsedOnLoad="false"
    :bodyClass="categoryValuesLength > itemsMaxLimit ? 'p-0 mb-3' : 'mb-3'"
    headerClass="mb-2"
  >
    <!-- "'wc-card-' + category.key"-->
    <template v-slot:headerTitle>
      <h4 class="title my-auto">{{ category.name }}</h4>
      <button
        class="my-auto ml-3 unstyled-btn"
        v-if="!isClear"
        @click.stop="clear()"
        :aria-label="$t('clearFilter')"
      >
        <font-awesome-icon class="clear-icon" :icon="['fa', 'circle-xmark']" />
      </button>
    </template>
    <template v-slot:cardBody>
      <!-- START:search box -->
      <WCSearchInput
        v-if="categoryValuesLength > itemsMaxLimit"
        :ariaLabel="$t('searchFilterCategory')"
        :placeHolderText="$t('search')"
        @focusIn="hasFocus = true"
        @focusOut="hasFocus = false"
        :hasFocusInput="hasFocus"
        @onSearch="updateSearchValue"
        @updateValue="updateSearchValue"
        @onClear="updateSearchValue"
        :updatedSearchInput="searchInput"
      />
      <!-- END:search box -->
      <div
        :class="{
          'wc-wrapper-scroll overflow-auto pl-3 pr-4': categoryValuesLength > itemsMaxLimit,
        }"
      >
        <div
          class="row justify-content-between py-1 border-bottom"
          v-for="value in filteredItems()"
          :key="value.key"
        >
          <div class="wc-filter-checkbox">
            <WCCheckbox
              :id="'search-filter-checkbox-' + category.key + '-' + value.key"
              @change="onChange(category, value, $event)"
              :model="value.selected"
              :label="value.name"
            >
              <WCSearchFilterCategoryItem :itemValue="value.name" />
            </WCCheckbox>
          </div>
          <span class="float-right">{{ value.count }}</span>
        </div>
      </div>
    </template>
  </WCCollapseCard>
</template>

<script>
import WCCheckbox from '@/modules/forms/components/WCCheckbox/WCCheckbox.vue';
import WCSearchFilterCategoryItem from '@/components/WCSearchFilterCategoryItem/WCSearchFilterCategoryItem.vue';
import { FILTER_ITEMS_MAX_LIMIT } from '@/constants/AppConstants';
import WCSearchInput from '@/components/WCSearchInput/WCSearchInput.vue';
import WCCollapseCard from '../WCCollapseCard/WCCollapseCard.vue';

export default {
  components: {
    WCCollapseCard,
    WCCheckbox,
    WCSearchFilterCategoryItem,
    WCSearchInput,
  },
  model: {
    prop: 'category',
    event: 'change',
  },
  props: {
    category: {},
    categoryItemSearchInput: {
      type: String,
    },
    categoryName: {
      type: String,
    },
  },
  data() {
    return {
      searchInput: this.categoryName === this.category.name ? this.categoryItemSearchInput : '',
      hasFocus: false,
      itemsMaxLimit: FILTER_ITEMS_MAX_LIMIT,
    };
  },
  computed: {
    categoryValuesLength() {
      return this.category.values.length;
    },
    isClear() {
      return !this.category.values.some(value => value.selected);
    },
  },
  methods: {
    updateSearchValue(searchValue) {
      this.searchInput = searchValue;
      this.$emit('categoryItemSearchInput', this.searchInput, this.category.name);
      this.filteredItems();
    },
    onChange(category, value, $event) {
      this.$emit('change', category, value, $event);
    },
    clear() {
      this.$emit('clearCategoryFilter', this.category);
    },
    filteredItems() {
      const self = this;
      if (this.searchInput) {
        return this.category.values.filter(function(item) {
          return item.name.toLowerCase().indexOf(self.searchInput.toLowerCase()) >= 0;
        });
      }
      return this.category.values;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-wrapper-scroll {
  height: rem(250px);
}

.clear-icon {
  color: black;
  font-size: $font-size-base;
}

::v-deep.wc-filter-checkbox {
  max-width: 75%;
  .custom-control-label {
    width: 100%;
  }
}
.wc-search-area {
  margin-bottom: 0.5rem;
  .wc-search-box {
    &.form-control {
      padding-left: 1.25rem;
      padding-right: 0;
      &:focus {
        box-shadow: none;
        border-color: var(--gray-400, $gray-400);
      }
    }
    border-right: 0 !important;
  }
  .search-btn {
    border: 1px solid var(--gray-400, $gray-400) !important;
    border-left: 0 !important;
  }
}
</style>
